





















import { Vue, Component } from 'vue-property-decorator'
import BaseEnroll from './components/common/BaseEnroll.vue'
import ArtMailForm from './components/ArtMailForm.vue'
import { ConfigStore } from '@/store/config'
import {
  fetchArtStudentEnroll,
  createArtStudentEnroll,
  updateArtStudentEnroll
} from '@/apis/enroll/artMailInfo'
import type { ArtMailInfo as ArtMailInfoModel } from '@/models/enrolls/artMailInfo'
import type { Entry } from "@/models/enrolls/enroll"

@Component({
  components: { BaseEnroll, ArtMailForm }
})
export default class ArtMail extends Vue {
  ajaxFetch = fetchArtStudentEnroll
  ajaxCreate = createArtStudentEnroll
  ajaxUpdate = updateArtStudentEnroll
  form: ArtMailInfoModel = {
    studentId: '',
    collegeExaminationNumber: '',
    idCard: '',
    name: '',
    gender: '',
    mailPicAdd: '',
    birth: '',
    phone:'',
    collegeExaminationLocation:'',
    homePhone:'',
    mailSendTime:'',
    mailAccount:'',

  }
  nowDate = new Date();

  get config() {
    return (
      ConfigStore.configs.find(a => a.key === 'art-mail')
        ?.value ?? {}
    )
  }

  notice = this.nowDate.getFullYear()+this.config.notice
  title = this.nowDate.getFullYear()+this.config.title

}
